import { useNavigate } from "react-router-dom";
import { useContent } from "../ContentContext";
import "./Banner.css";

const Banner = ({ imageUrl: propImageUrl }) => {
  const { content, loading } = useContent();
  const navigate = useNavigate();

  if (loading || !content) {
    return <div style={{ height: "600px", background: "#f0f0f0", display: "flex", justifyContent: "center", alignItems: "center" }}>Loading Banner...</div>;
  }

  const { banner } = content;
  const imageUrl = propImageUrl || banner.imageUrl;

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "600px", // adjust height as needed
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    overflow: "hidden",
    fontSize: "15px",
    color: "rgb(255, 255, 255)",
    fontWeight: 700,
    fontFamily: "'Inter', sans-serif",
    textTransform: "uppercase",
    letterSpacing: "0.2em",
    lineHeight: 1.2,
  };



  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.18) 40%)",
    pointerEvents: "none", // let clicks pass through
    fontFamily: "'Inter', sans-serif",

  };

  const contentStyle = {
    position: "relative",
    zIndex: 2,
    maxWidth: "700px",
    padding: "20px",
    fontSize: '130%',
    fontFamily: "'Inter', sans-serif",

  };
  const contentStyles = {
    fontWeight: "600",
    fontSize: "44px",
    margin: 0,
    fontFamily: "'Inter', sans-serif",

  };

  // const buttonStyle = {
  //   marginTop: "20px",
  //   padding: "10px 30px",
  //   fontSize: "1rem",
  //   border: "1px solid #ffffffff",
  //   // backgroundColor: "#fff",
  //   cursor: "pointer",
  //   color: "#000000ff",
  //   fontFamily: "'Montserrat', sans-serif",
  //   fontWeight: 700,
  //   textTransform: "uppercase",
  //   letterSpacing: "0.2em",
  //   lineHeight: 1.2,


  // };


  const styles = {
    buttonContainer: {
      display: 'flex',
      gap: '20px',
      justifyContent: 'center',
      marginTop: '30px',
      flexWrap: 'wrap'
    },
    button: {
      backgroundColor: "white",
      color: "black",
      border: "none",
      padding: "14px 32px",
      fontWeight: "600",
      cursor: "pointer",
      borderRadius: "3px",
      letterSpacing: "0.05em",
      fontFamily: "'Inter', sans-serif",
      minWidth: '160px'
    },
    learnMoreBtn: {
      backgroundColor: "transparent",
      color: "white",
      border: "1px solid white",
      padding: "14px 32px",
      fontWeight: "600",
      cursor: "pointer",
      borderRadius: "3px",
      letterSpacing: "0.05em",
      fontFamily: "'Inter', sans-serif",
      minWidth: '160px'
    }
  }


  const handleClick = () => {
    navigate(banner.buttonLink || "/contact");
  };

  return (
    <div style={containerStyle}>
      <div style={overlayStyle}></div>
      <div style={contentStyle} className="banner-content-wrapper">
        <p>{banner.subtext}</p>
        <h1 style={contentStyles} className="banner-title">
          {banner.title}
        </h1>
        <br />
        <br />
        <div style={styles.buttonContainer} className="banner-buttons-container">
          <button style={styles.button} className="banner-button" onClick={handleClick}>
            {banner.buttonText}
          </button>
          {/* <button style={styles.learnMoreBtn} className="banner-learn-more-btn" onClick={() => navigate("/about")}>
            LEARN MORE
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default Banner;
